module.exports = __webpack_public_path__ + "static/img/Group 356.467cb6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group 356.png
// module id = Jkxe
// module chunks = 13